import auth from './auth';
import preview from './preview';

const api = {
   auth,
   preview,
};

export default api;
